import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'
import { useTheme } from 'embed/hooks'

const defaultStyles = require('./styles.scss')

export interface ToggleFilterListProps {
  filters: ToggleFilter[]
  onToggleFilterClick: (filterValue: unknown) => void
  customStyles?: ToggleFilterListStyles | undefined
  testId?: string | undefined
}

export interface ToggleFilterListStyles {
  toggleFilterListContainer?: string
  toggleFilterList?: string
}

export interface ToggleFilter {
  active: boolean
  label: string
  value: number | string
}

interface ToggleFilterProps extends ToggleFilter {
  onToggleFilterClick: (filterValue: unknown) => void
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
const ToggleFilter: React.FC<ToggleFilterProps> = ({ onToggleFilterClick, value, label, active }) => {
  const { colorSecondary } = useTheme()
  const onFilterClick = React.useCallback(() => onToggleFilterClick(value), [onToggleFilterClick])
  return (
    <li
      className={classnames(
        defaultStyles.toggleFilterItem,
        { [defaultStyles.toggleFilterItemInactive]: !active },
        {
          [css(`
            color: white;
            background-color: ${colorSecondary};
            :hover {
              opacity: 0.84;
            }
          `)]: active,
        },
      )}
      key={value}
      onClick={onFilterClick}
    >
      <div className={classnames(defaultStyles.toggleFilterItemLabel)}>{label}</div>
    </li>
  )
}

const ToggleFilterList: React.FC<ToggleFilterListProps> = ({ filters, onToggleFilterClick, customStyles, testId }) => {
  const { borderRadiusSmall, colorBorder } = useTheme()
  return (
    <div
      className={classnames(defaultStyles.toggleFilterListContainer, customStyles?.toggleFilterListContainer)}
      data-test-id={testId ? testId : 'toggleFilterList'}
    >
      <ul
        className={classnames(
          defaultStyles.toggleFilterList,
          customStyles?.toggleFilterList,
          css(`
              border-color: ${colorBorder} !important;
              border-radius: ${borderRadiusSmall}
            `),
        )}
      >
        {filters.map(({ active, label, value }) => (
          <ToggleFilter
            key={value}
            label={label}
            value={value}
            active={active}
            onToggleFilterClick={onToggleFilterClick}
          />
        ))}
      </ul>
    </div>
  )
}

export default ToggleFilterList
